import Vue from 'vue'
import Router from 'vue-router'
import zkjg from "../view/zkjg";
import rwxq from "../view/rwxq";
import index from "../view/index";
import zhSearch from "../view/zhSearch";
import no from "../view/no";
import before from "../view/before";
import { validateToken } from "../api/persons";

Vue.use(Router)

const router = new Router({
  mode: "history", // 使用 HTML5 history 模式，清除 URL 中的 #
  routes: [
    {
      path: "/",
      name: "before",
      component: before,
    },
    {
      path: '/no',
      name: 'no',
      component: no
    },
    {
      path: '/zkjg',
      name: 'zkjg',
      component: zkjg,
      meta: { requiresAuth: true }, // 需要登录权限
    },
    {
      path: '/rwxq',
      name: 'rwxq',
      component: rwxq,
      meta: { requiresAuth: true }, // 需要登录权限
    },
    {
      path: '/zhSearch',
      name: 'zhSearch',
      component: zhSearch,
      meta: { requiresAuth: true }, // 需要登录权限
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: { requiresAuth: true }, // 需要登录权限
    },
    {
      path: "*",
      redirect: "/", // 未匹配的路由重定向
    }
  ],
});

// 全局路由守卫
// router.beforeEach((to, from, next) => {
//   // 获取本地存储的 token
//   const token = localStorage.getItem("token");

//   // 判断目标路由是否需要登录
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (token) {
//       // 假设存在后台接口校验，异步验证 token 是否有效
//       validateToken({ code: token }).then((result) => {
//         if (result.code == "200") {
//           next(); // 如果 token 有效，放行
//         } else {
//           next("/no"); // token 无效，跳转登录
//         }
//       });
//     } else {
//       next("/no");
//     }
//   } else {
//     next(); // 不需要登录权限的路由直接放行
//   }
// });

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js